module.exports = __webpack_public_path__ + "static/media/2_6.4e469ac5.png";